<template>
  <div class="q-pa-lg">
    <div class="row justify-between items-start">
      <h1>Логи <span class="data-rows-number">{{ totalLogs }}</span></h1>
    </div>
    <logs-list/>
  </div>
</template>

<script>
import LogsList from "../components/LogsList/LogsList";

import {mapGetters} from "vuex";

export default {
  name: "ProjectLogsView",

  components: {LogsList},

  computed: mapGetters({
    totalLogs: 'logsList/total'
  })
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/views/ProjectLogsView.vue